var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ecomm" },
    [
      _c(
        "v-alert",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.alert,
              expression: "alert"
            }
          ],
          attrs: {
            color: "secondary",
            icon: "warning",
            value: "true",
            outline: ""
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("ecommWarning")) + "\n  ")]
      ),
      _vm._v(" "),
      _vm.loadingGet
        ? _c(
            "div",
            { staticClass: "text-xs-center" },
            [
              _c("v-progress-circular", {
                staticClass: "primary--text",
                attrs: { indeterminate: "", size: 100, width: 1 }
              })
            ],
            1
          )
        : _c(
            "div",
            [
              _c(
                "v-card",
                { staticClass: "mb-3" },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md4: "" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.cms,
                                  dense: "",
                                  label: _vm._f("cap")(
                                    _vm.$t("select") + " CMS"
                                  ),
                                  hint: _vm.$t("cmsSettingsHint"),
                                  "persistent-hint": "",
                                  "return-object": ""
                                },
                                model: {
                                  value: _vm.form.cms,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "cms", $$v)
                                  },
                                  expression: "form.cms"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md2: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "primary--text",
                                  attrs: {
                                    flat: "",
                                    block: _vm.$vuetify.breakpoint.xsOnly
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.cmsChanged()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("applyCmsSettings")))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-expansion-panel",
                [
                  _c(
                    "v-expansion-panel-content",
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("v-icon", { staticClass: "mr-2 primary--text" }, [
                            _vm._v("insert_drive_file")
                          ]),
                          _vm._v("Pages")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { staticClass: "grey lighten-3" },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-expansion-panel",
                                { staticClass: "mb-3" },
                                [
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            slot: "header",
                                            "align-center": "",
                                            row: "",
                                            spacer: "",
                                            ellipsis: ""
                                          },
                                          slot: "header"
                                        },
                                        [
                                          _c("v-flex", { attrs: { xs2: "" } }, [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm._f("cap")(
                                                    _vm.$t("basket")
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.form.opt_1.text &&
                                          _vm.form.input_1
                                            ? _c(
                                                "v-flex",
                                                {
                                                  attrs: {
                                                    xs10: "",
                                                    "hidden-sm-and-down": ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t("contains")
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.form.opt_1.text
                                                      ) +
                                                      " : "
                                                  ),
                                                  _c("code", [
                                                    _vm._v(
                                                      _vm._s(_vm.form.input_1)
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card",
                                        { staticClass: "grey lighten-3" },
                                        [
                                          _c(
                                            "v-card-text",
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  label: _vm._f("cap")(
                                                    _vm.$t("contains")
                                                  ),
                                                  items: _vm.opts,
                                                  "return-object": ""
                                                },
                                                model: {
                                                  value: _vm.form.opt_1,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "opt_1",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.opt_1"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm._f("cap")(
                                                    _vm.$t("urlString")
                                                  )
                                                },
                                                model: {
                                                  value: _vm.form.input_1,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "input_1",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.input_1"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            slot: "header",
                                            "align-center": "",
                                            row: "",
                                            spacer: "",
                                            ellipsis: ""
                                          },
                                          slot: "header"
                                        },
                                        [
                                          _c("v-flex", { attrs: { xs2: "" } }, [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm._f("cap")(
                                                    _vm.$t("identification")
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.form.opt_2.text &&
                                          _vm.form.input_2
                                            ? _c(
                                                "v-flex",
                                                {
                                                  attrs: {
                                                    xs10: "",
                                                    "hidden-sm-and-down": ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t("contains")
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.form.opt_2.text
                                                      ) +
                                                      " : "
                                                  ),
                                                  _c("code", [
                                                    _vm._v(
                                                      _vm._s(_vm.form.input_2)
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card",
                                        { staticClass: "grey lighten-3" },
                                        [
                                          _c(
                                            "v-card-text",
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  label: _vm._f("cap")(
                                                    _vm.$t("contains")
                                                  ),
                                                  items: _vm.opts,
                                                  "return-object": ""
                                                },
                                                model: {
                                                  value: _vm.form.opt_2,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "opt_2",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.opt_2"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm._f("cap")(
                                                    _vm.$t("urlString")
                                                  )
                                                },
                                                model: {
                                                  value: _vm.form.input_2,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "input_2",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.input_2"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            slot: "header",
                                            "align-center": "",
                                            row: "",
                                            spacer: "",
                                            ellipsis: ""
                                          },
                                          slot: "header"
                                        },
                                        [
                                          _c("v-flex", { attrs: { xs2: "" } }, [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm._f("cap")(
                                                    _vm.$t("delivery")
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.form.opt_3.text &&
                                          _vm.form.input_3
                                            ? _c(
                                                "v-flex",
                                                {
                                                  attrs: {
                                                    xs10: "",
                                                    "hidden-sm-and-down": ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t("contains")
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.form.opt_3.text
                                                      ) +
                                                      " : "
                                                  ),
                                                  _c("code", [
                                                    _vm._v(
                                                      _vm._s(_vm.form.input_3)
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card",
                                        { staticClass: "grey lighten-3" },
                                        [
                                          _c(
                                            "v-card-text",
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  label: _vm._f("cap")(
                                                    _vm.$t("contains")
                                                  ),
                                                  items: _vm.opts,
                                                  "return-object": ""
                                                },
                                                model: {
                                                  value: _vm.form.opt_3,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "opt_3",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.opt_3"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm._f("cap")(
                                                    _vm.$t("urlString")
                                                  )
                                                },
                                                model: {
                                                  value: _vm.form.input_3,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "input_3",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.input_3"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            slot: "header",
                                            "align-center": "",
                                            row: "",
                                            spacer: "",
                                            ellipsis: ""
                                          },
                                          slot: "header"
                                        },
                                        [
                                          _c("v-flex", { attrs: { xs2: "" } }, [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm._f("cap")(
                                                    _vm.$t("summary")
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.form.opt_4.text &&
                                          _vm.form.input_4
                                            ? _c(
                                                "v-flex",
                                                {
                                                  attrs: {
                                                    xs10: "",
                                                    "hidden-sm-and-down": ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t("contains")
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.form.opt_4.text
                                                      ) +
                                                      " : "
                                                  ),
                                                  _c("code", [
                                                    _vm._v(
                                                      _vm._s(_vm.form.input_4)
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card",
                                        { staticClass: "grey lighten-3" },
                                        [
                                          _c(
                                            "v-card-text",
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  label: _vm._f("cap")(
                                                    _vm.$t("contains")
                                                  ),
                                                  items: _vm.opts,
                                                  "return-object": ""
                                                },
                                                model: {
                                                  value: _vm.form.opt_4,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "opt_4",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.opt_4"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm._f("cap")(
                                                    _vm.$t("urlString")
                                                  )
                                                },
                                                model: {
                                                  value: _vm.form.input_4,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "input_4",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.input_4"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            slot: "header",
                                            "align-center": "",
                                            row: "",
                                            spacer: "",
                                            ellipsis: ""
                                          },
                                          slot: "header"
                                        },
                                        [
                                          _c("v-flex", { attrs: { xs2: "" } }, [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm._f("cap")(
                                                    _vm.$t("payment")
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.form.opt_5.text &&
                                          _vm.form.input_5
                                            ? _c(
                                                "v-flex",
                                                {
                                                  attrs: {
                                                    xs10: "",
                                                    "hidden-sm-and-down": ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t("contains")
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.form.opt_5.text
                                                      ) +
                                                      " : "
                                                  ),
                                                  _c("code", [
                                                    _vm._v(
                                                      _vm._s(_vm.form.input_5)
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card",
                                        { staticClass: "grey lighten-3" },
                                        [
                                          _c(
                                            "v-card-text",
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  label: _vm._f("cap")(
                                                    _vm.$t("contains")
                                                  ),
                                                  items: _vm.opts,
                                                  "return-object": ""
                                                },
                                                model: {
                                                  value: _vm.form.opt_5,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "opt_5",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.opt_5"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm._f("cap")(
                                                    _vm.$t("urlString")
                                                  )
                                                },
                                                model: {
                                                  value: _vm.form.input_5,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "input_5",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.input_5"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            slot: "header",
                                            "align-center": "",
                                            row: "",
                                            spacer: "",
                                            ellipsis: ""
                                          },
                                          slot: "header"
                                        },
                                        [
                                          _c("v-flex", { attrs: { xs2: "" } }, [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm._f("cap")(
                                                    _vm.$t("validation")
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.form.opt_6.text &&
                                          _vm.form.input_6
                                            ? _c(
                                                "v-flex",
                                                {
                                                  attrs: {
                                                    xs10: "",
                                                    "hidden-sm-and-down": ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t("contains")
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.form.opt_6.text
                                                      ) +
                                                      " : "
                                                  ),
                                                  _c("code", [
                                                    _vm._v(
                                                      _vm._s(_vm.form.input_6)
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card",
                                        { staticClass: "grey lighten-3" },
                                        [
                                          _c(
                                            "v-card-text",
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  label: _vm._f("cap")(
                                                    _vm.$t("contains")
                                                  ),
                                                  items: _vm.opts,
                                                  "return-object": ""
                                                },
                                                model: {
                                                  value: _vm.form.opt_6,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "opt_6",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.opt_6"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm._f("cap")(
                                                    _vm.$t("urlString")
                                                  )
                                                },
                                                model: {
                                                  value: _vm.form.input_6,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "input_6",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.input_6"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("v-icon", { staticClass: "mr-2 primary--text" }, [
                            _vm._v("add_shopping_cart")
                          ]),
                          _vm._v(_vm._s(_vm.$t("addToTheBasket")))
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { staticClass: "grey lighten-3" },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-expansion-panel",
                                { staticClass: "mb-3" },
                                [
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            slot: "header",
                                            "align-center": "",
                                            row: "",
                                            spacer: "",
                                            ellipsis: ""
                                          },
                                          slot: "header"
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs5: "", md2: "" } },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm._f("cap")(
                                                      _vm.$t("button")
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.form.input_r_1
                                            ? _c(
                                                "v-flex",
                                                { attrs: { xs7: "" } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "hidden-sm-and-down"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("identifiedBy")
                                                        ) + " :"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("code", [
                                                    _vm._v(
                                                      _vm._s(_vm.form.r_1) +
                                                        _vm._s(
                                                          _vm.form.input_r_1
                                                        )
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card",
                                        { staticClass: "grey lighten-3" },
                                        [
                                          _c(
                                            "v-card-text",
                                            [
                                              _c(
                                                "v-radio-group",
                                                {
                                                  attrs: { row: "" },
                                                  model: {
                                                    value: _vm.form.r_1,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "r_1",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.r_1"
                                                  }
                                                },
                                                [
                                                  _c("v-radio", {
                                                    staticClass:
                                                      "primary--text",
                                                    attrs: {
                                                      label: "class",
                                                      value: "."
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-radio", {
                                                    staticClass:
                                                      "primary--text",
                                                    attrs: {
                                                      label: "id",
                                                      value: "#"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm._f("cap")(
                                                    _vm.$t("name")
                                                  )
                                                },
                                                model: {
                                                  value: _vm.form.input_r_1,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "input_r_1",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.input_r_1"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            slot: "header",
                                            "align-center": "",
                                            row: "",
                                            spacer: "",
                                            ellipsis: ""
                                          },
                                          slot: "header"
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs5: "", md2: "" } },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm._f("cap")(
                                                      _vm.$t("priceOfProduct")
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.form.input_r_2
                                            ? _c(
                                                "v-flex",
                                                { attrs: { xs7: "" } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "hidden-sm-and-down"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("identifiedBy")
                                                        ) + " :"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("code", [
                                                    _vm._v(
                                                      _vm._s(_vm.form.r_2) +
                                                        _vm._s(
                                                          _vm.form.input_r_2
                                                        )
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card",
                                        { staticClass: "grey lighten-3" },
                                        [
                                          _c(
                                            "v-card-text",
                                            [
                                              _c(
                                                "v-radio-group",
                                                {
                                                  attrs: { row: "" },
                                                  model: {
                                                    value: _vm.form.r_2,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "r_2",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.r_2"
                                                  }
                                                },
                                                [
                                                  _c("v-radio", {
                                                    staticClass:
                                                      "primary--text",
                                                    attrs: {
                                                      label: "class",
                                                      value: "."
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-radio", {
                                                    staticClass:
                                                      "primary--text",
                                                    attrs: {
                                                      label: "id",
                                                      value: "#"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm._f("cap")(
                                                    _vm.$t("name")
                                                  )
                                                },
                                                model: {
                                                  value: _vm.form.input_r_2,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "input_r_2",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.input_r_2"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            slot: "header",
                                            "align-center": "",
                                            row: "",
                                            spacer: "",
                                            ellipsis: ""
                                          },
                                          slot: "header"
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs5: "", md2: "" } },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm._f("cap")(
                                                      _vm.$t("productName")
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.form.input_r_3
                                            ? _c(
                                                "v-flex",
                                                { attrs: { xs7: "" } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "hidden-sm-and-down"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("identifiedBy")
                                                        ) + " :"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("code", [
                                                    _vm._v(
                                                      _vm._s(_vm.form.r_3) +
                                                        _vm._s(
                                                          _vm.form.input_r_3
                                                        )
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card",
                                        { staticClass: "grey lighten-3" },
                                        [
                                          _c(
                                            "v-card-text",
                                            [
                                              _c(
                                                "v-radio-group",
                                                {
                                                  attrs: { row: "" },
                                                  model: {
                                                    value: _vm.form.r_3,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "r_3",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.r_3"
                                                  }
                                                },
                                                [
                                                  _c("v-radio", {
                                                    staticClass:
                                                      "primary--text",
                                                    attrs: {
                                                      label: "class",
                                                      value: "."
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-radio", {
                                                    staticClass:
                                                      "primary--text",
                                                    attrs: {
                                                      label: "id",
                                                      value: "#"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm._f("cap")(
                                                    _vm.$t("name")
                                                  )
                                                },
                                                model: {
                                                  value: _vm.form.input_r_3,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "input_r_3",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.input_r_3"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("v-icon", { staticClass: "mr-2 primary--text" }, [
                            _vm._v("shopping_cart")
                          ]),
                          _vm._v(_vm._s(_vm._f("cap")(_vm.$t("basket"))))
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { staticClass: "grey lighten-3" },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-expansion-panel",
                                { staticClass: "mb-3" },
                                [
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            slot: "header",
                                            "align-center": "",
                                            row: "",
                                            spacer: "",
                                            ellipsis: ""
                                          },
                                          slot: "header"
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs5: "", md2: "" } },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm._f("cap")(
                                                      _vm.$t("amount")
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.form.input_r_4
                                            ? _c(
                                                "v-flex",
                                                { attrs: { xs7: "" } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "hidden-sm-and-down"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("identifiedBy")
                                                        ) + " :"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("code", [
                                                    _vm._v(
                                                      _vm._s(_vm.form.r_4) +
                                                        _vm._s(
                                                          _vm.form.input_r_4
                                                        )
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card",
                                        { staticClass: "grey lighten-3" },
                                        [
                                          _c(
                                            "v-card-text",
                                            [
                                              _c(
                                                "v-radio-group",
                                                {
                                                  attrs: { row: "" },
                                                  model: {
                                                    value: _vm.form.r_4,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "r_4",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.r_4"
                                                  }
                                                },
                                                [
                                                  _c("v-radio", {
                                                    staticClass:
                                                      "primary--text",
                                                    attrs: {
                                                      label: "class",
                                                      value: "."
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-radio", {
                                                    staticClass:
                                                      "primary--text",
                                                    attrs: {
                                                      label: "id",
                                                      value: "#"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm._f("cap")(
                                                    _vm.$t("name")
                                                  )
                                                },
                                                model: {
                                                  value: _vm.form.input_r_4,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "input_r_4",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.input_r_4"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            slot: "header",
                                            "align-center": "",
                                            row: "",
                                            spacer: "",
                                            ellipsis: ""
                                          },
                                          slot: "header"
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs5: "", md2: "" } },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm._f("cap")(
                                                      _vm.$tc("items", 2, {
                                                        count: ""
                                                      })
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.form.input_r_5
                                            ? _c(
                                                "v-flex",
                                                { attrs: { xs7: "" } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "hidden-sm-and-down"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("identifiedBy")
                                                        ) + " :"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("code", [
                                                    _vm._v(
                                                      _vm._s(_vm.form.r_5) +
                                                        _vm._s(
                                                          _vm.form.input_r_5
                                                        )
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card",
                                        { staticClass: "grey lighten-3" },
                                        [
                                          _c(
                                            "v-card-text",
                                            [
                                              _c(
                                                "v-radio-group",
                                                {
                                                  attrs: { row: "" },
                                                  model: {
                                                    value: _vm.form.r_5,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "r_5",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.r_5"
                                                  }
                                                },
                                                [
                                                  _c("v-radio", {
                                                    staticClass:
                                                      "primary--text",
                                                    attrs: {
                                                      label: "class",
                                                      value: "."
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-radio", {
                                                    staticClass:
                                                      "primary--text",
                                                    attrs: {
                                                      label: "id",
                                                      value: "#"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm._f("cap")(
                                                    _vm.$t("name")
                                                  )
                                                },
                                                model: {
                                                  value: _vm.form.input_r_5,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "input_r_5",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.input_r_5"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-xs-right" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        flat: "",
                        dark: "",
                        block: _vm.$vuetify.breakpoint.xsOnly
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.reset()
                        }
                      }
                    },
                    [
                      _vm._v(_vm._s(_vm.$t("cancel"))),
                      _c(
                        "v-icon",
                        { staticClass: "primary--text", attrs: { right: "" } },
                        [_vm._v("settings_backup_restore")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        block: _vm.$vuetify.breakpoint.xsOnly,
                        loading: _vm.loadingPost,
                        disabled: _vm.alert
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.submit()
                        }
                      }
                    },
                    [
                      _vm._v(_vm._s(_vm.$t("save"))),
                      _c("v-icon", { attrs: { dark: "", right: "" } }, [
                        _vm._v("save")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a781116", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a781116","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Ecomm.vue
// module id = null
// module chunks = 